module.exports = __webpack_public_path__ + "static/media/vacuum-robot.e1bcc57e.svg";